import { AnyAction } from "redux";

import { setCartItems, toggleCartOpen } from "./cart.action";

import { CartItem } from "./cart.types";

export type CartState = {
  readonly cartItems: CartItem[];
  readonly isCartOpen: boolean;
  // readonly cartTotal: number;
  // readonly itemCount: number;
};

const CART_INITIAL_STATE: CartState = {
  cartItems: [],
  isCartOpen: false,
  // cartTotal: 0,
  // itemCount: 0,
};

export const cartReducer = (
  state = CART_INITIAL_STATE,
  action: AnyAction
): CartState => {
  //const { type, payload } = action;
  if (setCartItems.match(action)) {
    return {
      ...state,
      cartItems: action.payload,
    };
  }
  if (toggleCartOpen.match(action)) {
    return {
      ...state,
      isCartOpen: action.payload,
    };
  }
  return state;

  // switch (type) {
  //   case CART_ACTION_TYPES.SET_CART_ITEMS:
  //     return {
  //       ...state,
  //       cartItems: payload,
  //     };
  //   case CART_ACTION_TYPES.TOGGLE_CART:
  //     return {
  //       ...state,
  //       isCartOpen: payload,
  //     };
  //   default:
  //     return state;
  // }
};
